import { render } from "./DeviceProfileShow.vue?vue&type=template&id=30287a88"
import script from "./DeviceProfileShow.vue?vue&type=script&lang=js"
export * from "./DeviceProfileShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__